import React from "react";
import { STATUS_BADGE } from "../../lib/sales";

export default function DataStatusBadge({ status, className = "" }) {
  const meta = STATUS_BADGE[status] || STATUS_BADGE.UNAVAILABLE;
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider ${className}`}
      style={{ color: meta.color, background: meta.bg }} data-testid={`status-${(status || "").toLowerCase().replace(/\s+/g, "-")}`}>
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: meta.color }} />
      {meta.label}
    </span>
  );
}
